import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './themes.css';
import 'katex/dist/katex.min.css';
import './styles/codeHighlight.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from './i18n/LanguageContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <LanguageProvider>
    <App />
  </LanguageProvider>
);

// api.get('/api/csrf/')
//   .then(() => console.log("CSRF token initialized"))
//   .catch(err => console.error("CSRF token error", err));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
